import { Suspense } from 'react';
import { Outlet } from "react-router-dom";

import { Menu } from "./Menu/menu";
import { Footer } from "./Footer/footer";
import { ErrorBoundary } from "../../../Common/ErrorBoundary/errorBoundary.jsx";
import { SimpleLoader } from "../../../Common/Loader/simpleLoader.jsx";

export function Layout(props) {
    return (
        <div>
            <Menu {...props} />
            <ErrorBoundary>
                <Suspense fallback={<SimpleLoader />}>
                    <Outlet />
                </Suspense>
            </ErrorBoundary>
            <Footer {...props} />
        </div>
    );
}